import type { FC } from 'react';
import React from 'react';
import { Box, Body, Flex, Glyph } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import type { Stopover } from '@/components/FlightSummary/Segment/resolver';

interface CovidRestrictionMapItineraryProps {
  country: Stopover['vinRestriction']['country'];
}

const CovidRestrictionMapItinerary: FC<CovidRestrictionMapItineraryProps> = ({
  country,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex alignItems="start" mt="1x_small">
        <Glyph
          size="small"
          color="blue.70"
          category="Alerts"
          name="InfoCircle"
        />
        <Box pl="2x_small">
          <Body color="blue.70" weight="medium" type="xSmall">
            {t('flightSummary.itinerary.stopInfo.vinmessage.title')}
          </Body>
        </Box>
      </Flex>
      <Flex flexDirection="column">
        <Box pl="base" ml="2x_small">
          <Body color="blue.70" type="xSmall">
            {t('flightSummary.itinerary.stopInfo.vinmessage.body', { country })}
          </Body>
        </Box>
      </Flex>
    </>
  );
};

export default CovidRestrictionMapItinerary;
